import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteOteFpa = ({ oteFpaId }: { oteFpaId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/OteFpa/DeleteOteFpa/${oteFpaId}`);
};

type QueryFnType = typeof deleteOteFpa;

type UseDeleteOteFpaOptions = {
  oteFpaId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteOteFpa = ({ config }: UseDeleteOteFpaOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllOteFpas"]);
      addNotification(`Η Κατηγορίας ΦΠΑ Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteOteFpa,
  });
};
